import { EditorSettings } from '../interfaces/settings';

export const editorSettings: EditorSettings = {
    fontSize: 12,
    fontFamily: "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, 'Noto Sans', 'Liberation Sans', sans-serif",

    // dialog properties
    dialog: {
        name: 'NewDialog',
        title: 'New dialog',
        language: 'en_US',
        runtimeProvider: 'R',
        width: '560',
        height: '400',
        fontSize: '12',
        background: '#FFFFFF',
    },
}
